<div *ngIf="loaded$ | async">
  <ub-card [rounded]="true">
    <h1 title>{{ bookingItemOption.bookingItem.name }}
      <span *ngIf="bookingItemOption.id !== bookingItemOption.bookingItem._id">
        - {{ bookingItemOption.title }}
      </span>
    </h1>
    <div subtitle>
      <ul class="list-unstyled">
        <li *ngFor="let item of bookingItemOption.breadcrumbs; let last=last" style="display: inline-block">
          <span *ngIf="last">
            {{ item.title }}
          </span>
          <span *ngIf="!last">
            <a [routerLink]="['/', 'booking-items', bookingItemOption.bookingItem._id, 'view', item.id]">
              {{ item.title }}
            </a> >&nbsp;
          </span>
        </li>
      </ul>
    </div>
    <div actions>
      <eas-buttons-list [buttons]="buttons"></eas-buttons-list>
    </div>
  </ub-card>

  @if ($applyUrlVisible()) {
    <ub-card [rounded]="true">
      <ub-label title><span text i18n>Share this link to allow candidates to apply directly to this booking option:</span></ub-label>
      <div content>
        <div class="copy-text__container">
          <span class="copy-text__text">{{ applyUrl }}</span>
          <button mat-flat-button (click)="copyApplyUrl()" i18n>
            <mat-icon>content_copy</mat-icon>
            Copy link
          </button>
        </div>
      </div>
    </ub-card>
  }

  <eas-booking-item-option-summary [bookingItemOption]="bookingItemOption">
  </eas-booking-item-option-summary>

  <eas-booking-item-option-table *ngIf="bookingItemOption" [bookingOption]="bookingItemOption"></eas-booking-item-option-table>

  <ub-card>
    <h2 title i18n>Bookings for {{ bookingItemOption.title }}</h2>
    <div content *ngIf="tableLoaded">
      <eas-interactive-table [options]="tableComponentOptions" (selectedItems)="onSelectedItems($event)"></eas-interactive-table>
      <!-- <eas-simple-table></eas-simple-table> -->
      <div class="actions-footer" *ngIf="selectedItems.total > 0">
        <ub-label text="{{selectedItems.total}} {{selectedItems.total === 1 ? 'booking' : 'bookings'}} selected" variant="none" i18n-label i18n-text></ub-label>
        <button mat-flat-button color="primary" type="button" (click)="doBulkAction()" i18n>
          Bulk action
        </button>
      </div>
    </div>
  </ub-card>

</div>
